import { H1 as BluBlocksH1, H2 as BluBlocksH2 } from "@bluframe/blublocks"
import styled from "styled-components"

export const H1 = styled(BluBlocksH1)`
  font-size: 22px;
  margin: 0;
`

export const H2 = styled(BluBlocksH2)`
  font-size: 20px;
  margin: 0;
`

export const Inputs = styled.div`
  align-items: center;
  column-gap: 20px;
  display: grid;
  justify-items: start;
  row-gap: 20px;
`

export const DesriptionAndSection = styled.div`
  column-gap: 20px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  justify-items: start;
  row-gap: 20px;
`

export const HeadingAndContent = styled.div`
  display: grid;
  row-gap: 10px;
`
